export default "__VITE_ASSET__ZCvYdOrz__"